<template>
    <div class="flex flex-wrap items-center gap-2">
        <!-- Show Example Button - only show when template exists -->
        <Button
            v-if="hasTemplate"
            variant="outline"
            size="sm"
            @click="$emit('load-template')"
            :aria-label="`Show example for ${currentTab?.label || 'current file'}`">
            <Code class="w-4 h-4 mr-2" />
            Show Example
        </Button>

        <!-- Save Button -->
        <LoadingButton
            size="sm"
            :is-loading="isSaving"
            :variant="hasUnsavedChanges ? 'default' : 'secondary'"
            @click="$emit('save')"
            :disabled="!hasUnsavedChanges || isSaving"
            :aria-label="hasUnsavedChanges ? 'Save changes' : 'All changes saved'">
            <Check class="w-4 h-4 mr-2" />
            <span v-if="hasUnsavedChanges">Save</span>
            <span v-else>Saved</span>
        </LoadingButton>
    </div>
</template>

<script setup>
import { Button } from '@/components/ui/button';
import { LoadingButton } from '@/components/ui/loading-button';
import { Code, Check, X } from 'lucide-vue-next';

defineProps({
    currentTab: {
        type: Object,
        default: null
    },
    isSaving: {
        type: Boolean,
        default: false
    },
    hasUnsavedChanges: {
        type: Boolean,
        default: false
    },
    hasTemplate: {
        type: Boolean,
        default: false
    }
});

defineEmits(['load-template', 'save']);
</script>

<style scoped>
@reference '../../../style.css';
/* Ensure buttons have proper focus states for accessibility */
.flex > * {
    @apply focus-visible:ring-2 focus-visible:ring-offset-2;
}
</style>
